































































import { Component, Watch, Emit, Prop, Ref } from 'nuxt-property-decorator'
import { cloneDeep } from 'lodash'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import { defaultSystemCode, SystemCode } from '@/api/models/system-code'
import {
  defaultUserMemo,
  defaultUserNote,
  UserMemo,
  UserNote
} from '@/api/models/user'
import { alertStore, modalErrorStore } from '@/utils/store-accessor'
import { Alert, AlertMessage, ErrorMessage, userApi } from '@/api'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { AlertFactory } from '@/factory'
import { AlertCodeALC00002 } from '@/types'
import { ModalTextArea } from '@/components/modals/ModalTextArea'
import { setErrorMessage } from '@/utils/error'
import UserMemoEditTable from './UserMemoEditTable.vue'
import UserNoteEditTable from './UserNoteEditTable.vue'

@Component({
  components: {
    ModalTextArea,
    UserMemoEditTable,
    UserNoteEditTable,
    ModalFooter
  }
})
export default class ModalEditMemoAndNote extends ModalComponentBaseVue {
  @Ref()
  userMemoEditTable!: UserMemoEditTable

  @Ref()
  userNoteEditTable!: UserNoteEditTable

  @Ref()
  modalTextArea!: ModalTextArea

  @Prop({
    type: String,
    required: true
  })
  id!: string

  @Prop({
    type: Array,
    required: true
  })
  memoItems!: UserMemo[]

  @Prop({
    type: Array,
    required: true
  })
  noteItems!: UserNote[]

  inputMemoCodes: SystemCode[] = []

  inputMemoItems: UserMemo[] = []

  inputNoteCodes: SystemCode[] = []

  inputNoteItems: UserNote[] = []

  dialog: boolean = false

  tableBodyHeight: number = 0

  @Watch('dialog')
  initialize(newVal: boolean) {
    if (newVal) {
      this.$nextTick(() => {
        this.calculateTableHeight()
      })
      return
    }

    this.tableBodyHeight = 0
  }

  @Watch('dialog')
  onShowChanged(val: boolean) {
    if (val) {
      this.opened()
    } else {
      this.closed()
    }
  }

  @Watch('memoItems', { immediate: true, deep: true })
  onChangeMemoItems() {
    this.initMemo()
  }

  @Watch('noteItems', { immediate: true, deep: true })
  onChangeNoteItems() {
    this.initNote()
  }

  mounted() {
    this.debug('mounted()')
    window.addEventListener('resize', this.onResize)
  }

  beforeDestroy() {
    this.debug('beforeDestroy()')
    window.removeEventListener('resize', this.onResize)
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase() / 2
    })
  }

  open(): void {
    this.dialog = true
    // this.init()
  }

  close(): void {
    this.dialog = false
  }

  initMemo() {
    this.inputMemoCodes = [defaultSystemCode()]
    this.inputMemoItems = [defaultUserMemo()]

    cloneDeep(this.memoItems)
      .reverse()
      .forEach((item: UserMemo) => {
        this.inputMemoCodes.push(defaultSystemCode())
        this.inputMemoItems.push(cloneDeep(item))
      })
  }

  initNote() {
    this.inputNoteCodes = [defaultSystemCode()]
    this.inputNoteItems = [defaultUserNote()]

    cloneDeep(this.noteItems)
      .reverse()
      .forEach((item: UserNote) => {
        this.inputNoteCodes.push(defaultSystemCode())
        this.inputNoteItems.push(cloneDeep(item))
      })
  }

  focusMemoInputCodeKey(index: number) {
    this.$nextTick(() => {
      this.userMemoEditTable.focus(index)
    })
  }

  focusNoteInputCodeKey(index: number) {
    this.$nextTick(() => {
      this.userNoteEditTable.focus(index)
    })
  }

  onInputMemoCode(systemCode: SystemCode, index: number): void {
    this.debug('onInputMemoCode', systemCode, index)
    this.inputMemoCodes[index] = systemCode
    this.inputMemoItems[index].memo = systemCode.name
  }

  onInputMemo(memo: string, index: number): void {
    this.debug('onInputMemo', memo, index)
    this.inputMemoItems[index].memo = memo
  }

  onInputMemoDisplayStartDate(displayStartDate: string, index: number): void {
    this.debug('onInputMemoDisplayStartDate', displayStartDate, index)
    this.inputMemoItems[index].displayStartDate.input = displayStartDate
    this.inputMemoItems[index].displayStartDate.errorMessage = ''
  }

  onInputMemoDisplayEndDate(displayEndDate: string, index: number): void {
    this.debug('onInputMemoDisplayEndDate', displayEndDate, index)
    this.inputMemoItems[index].displayEndDate.input = displayEndDate
    this.inputMemoItems[index].displayEndDate.errorMessage = ''
  }

  onClickMemoOpacDisplay(index: number): void {
    this.inputMemoItems[index].opacDisplay = !this.inputMemoItems[index]
      .opacDisplay
  }

  onClickMemoUserCheckedTimeDeleteFlag(index: number): void {
    this.inputMemoItems[index]._userCheckedTimeDeleteFlag = true
  }

  onClickMemoUserCheckedTimeDeleteFlagCancel(index: number): void {
    this.inputMemoItems[index]._userCheckedTimeDeleteFlag = false
  }

  onClickRemoveMemo(index: number): void {
    this.debug('onClickRemoveMemo', index)
    this.inputMemoCodes.splice(index, 1)
    this.inputMemoItems.splice(index, 1)
  }

  onClickAddMemo(): void {
    if (this.inputMemoItems.length > 0 && this.inputMemoItems[0].memo === '') {
      return
    }

    this.inputMemoCodes.unshift(defaultSystemCode())
    this.inputMemoItems.unshift(defaultUserMemo())
    this.focusMemoInputCodeKey(0)
  }

  onClickDetailMemo(index: number): void {
    this.modalTextArea.open({
      value: this.inputMemoItems[index].memo,
      title: '連絡メモの編集',
      fieldName: '連絡メモ',
      limitLinefeed: true,
      onClickOk: (value: string) => (this.inputMemoItems[index].memo = value)
    })
  }

  onInputNote(note: string, index: number): void {
    this.debug('onInputNote', note, index)
    this.inputNoteItems[index].note = note
  }

  onClickRemoveNote(index: number): void {
    this.debug('onClickRemoveNote', index)
    this.inputNoteCodes.splice(index, 1)
    this.inputNoteItems.splice(index, 1)
  }

  onClickAddNote(): void {
    if (this.inputNoteItems.length > 0 && this.inputNoteItems[0].note === '') {
      return
    }

    this.inputNoteCodes.unshift(defaultSystemCode())
    this.inputNoteItems.unshift(defaultUserNote())
    this.focusNoteInputCodeKey(0)
  }

  onClickDetailNote(index: number): void {
    this.modalTextArea.open({
      value: this.inputNoteItems[index].note,
      title: '注記の編集',
      fieldName: '注記',
      limitLinefeed: true,
      onClickOk: (value: string) => (this.inputNoteItems[index].note = value)
    })
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-edit-memos-and-notes')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onResize(): void {
    this.calculateTableHeight()
  }

  async update() {
    this.debug('update()')
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await userApi.updateMemoAndNoteById(
        this.id,
        this.createUpdateMemo(),
        this.createUpdateNote()
      )

      this.$emit('updated')

      this.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        console.log(this.memoItems)

        setErrorMessage(error.alerts, {
          memos: this.createUpdateMemo().map(item => ({
            displayStartDate: item.displayStartDate,
            displayEndDate: item.displayEndDate
          }))
        })
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  createUpdateMemo(): UserMemo[] {
    const memos = [...this.inputMemoItems].reverse().filter(item => {
      return item.memo !== ''
    })

    const removeMemos: UserMemo[] = this.memoItems
      .filter(item => {
        return !memos.find(findItem => {
          return findItem.id === item.id
        })
      })
      .map(item => {
        return {
          id: item.id,
          date: item.date,
          place: item.place,
          memo: item.memo,
          displayStartDate: {
            input: item.displayStartDate.input,
            errorMessage: ''
          },
          displayEndDate: {
            input: item.displayEndDate.input,
            errorMessage: ''
          },
          opacDisplay: item.opacDisplay,
          userCheckedTime: item.userCheckedTime,
          _userCheckedTimeDeleteFlag: item._userCheckedTimeDeleteFlag,
          revision: item.revision,
          _delete: true
        }
      })

    return memos.concat(removeMemos)
  }

  createUpdateNote(): UserNote[] {
    const notes = [...this.inputNoteItems].reverse().filter(item => {
      return item.note !== ''
    })

    const removeNotes: UserNote[] = this.noteItems
      .filter(item => {
        return !notes.find(findItem => {
          return findItem.id === item.id
        })
      })
      .map(item => {
        return {
          id: item.id,
          date: item.date,
          note: item.note,
          place: item.place,
          revision: item.revision,
          _delete: true
        }
      })

    return notes.concat(removeNotes)
  }

  @Emit('opened')
  opened(): void {}

  @Emit('closed')
  closed(): void {}

  @Emit('ok')
  onClickOk() {
    this.update()
  }

  @Emit('cancel')
  onClickCancel(): void {
    const alert: Alert = AlertFactory.create(AlertCodeALC00002)
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: () => {
        this.close()
      }
    })
  }
}
